import React from "react";
import { HiPlay, HiRefresh, HiX } from "react-icons/hi";
import { UseAgentTestLab } from "./useAgentTestLab";

interface BulkActionBarProps {
  lab: UseAgentTestLab;
}

export const BulkActionBar: React.FC<BulkActionBarProps> = ({ lab }) => {
  if (lab.selectedIds.length === 0) return null;

  const failedInSelection = lab.selectedIds.filter((id) =>
    lab.failedScenarios.some((scenario) => scenario.id === id)
  );
  const visibleSelectedCount = lab.visibleScenarios.filter((scenario) =>
    lab.selectedIds.includes(scenario.id)
  ).length;
  const hiddenSelectedCount = lab.selectedIds.length - visibleSelectedCount;
  const selectionLabel =
    hiddenSelectedCount > 0
      ? `${lab.selectedIds.length} selected across filters`
      : `${lab.selectedIds.length} selected`;

  return (
    <div className="sticky bottom-0 z-20 border-t border-[var(--border)] bg-[var(--card-container)]/95 backdrop-blur px-4 py-3 flex flex-wrap items-center gap-3">
      <div className="min-w-0">
        <div className="text-sm font-medium text-[var(--foreground)]">
          {selectionLabel}
        </div>
        {hiddenSelectedCount > 0 && (
          <div className="text-xs text-[var(--foreground-muted)]">
            {visibleSelectedCount} visible in this filter · {hiddenSelectedCount} hidden
          </div>
        )}
      </div>
      <div className="flex-1" />
      <button
        type="button"
        onClick={() => lab.setSelectedIds([])}
        className="px-3 py-1.5 text-sm rounded-md text-[var(--foreground-muted)] hover:text-[var(--foreground)] hover:bg-[var(--muted)] inline-flex items-center gap-1.5"
      >
        <HiX className="w-4 h-4" />
        Clear
      </button>
      <button
        type="button"
        onClick={lab.handleRerunFailed}
        disabled={lab.isRunning || failedInSelection.length === 0}
        className="px-3 py-1.5 text-sm rounded-md bg-[var(--muted)] text-[var(--foreground)] hover:bg-[var(--secondary)] disabled:opacity-40 inline-flex items-center gap-1.5"
      >
        <HiRefresh className="w-4 h-4" />
        Re-run failed ({failedInSelection.length})
      </button>
      <button
        type="button"
        onClick={lab.handleRunSelected}
        disabled={lab.isRunning || lab.selectedIds.length === 0}
        className="px-4 py-1.5 text-sm font-medium rounded-md bg-[var(--accent)] text-[var(--accent-foreground)] hover:bg-[var(--accent-hover)] disabled:opacity-50 inline-flex items-center gap-1.5"
      >
        <HiPlay className="w-4 h-4" />
        {lab.isRunning ? "Running…" : `Run selected (${lab.selectedIds.length})`}
      </button>
    </div>
  );
};
